import { Outlet } from 'react-router';

import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function ChatLayout() {
  return (
    <HeaderToolbarAndContentLayout actionSection={<></>} content={<Outlet />} />
  );
}
